import React from "react";
import "../../styles/customize-components/calendar-loader.css";

const CalendarLoader = ({
  daysCount = 7,
  shiftsPerDay = 3,
  className = "",
  // containerClassName = "weekly-roster-overview-grid",
}) => {
  const renderShiftSkeleton = () => (
    <div className="weekly-roster-overview-shift-row" style={{ opacity: 0.6 }}>
      <div className="weekly-roster-overview-shift-info-col">
        <div
          style={{
            height: "14px",
            width: "80px",
            backgroundColor: "#e0e0e0",
            borderRadius: "4px",
            marginBottom: "4px",
            animation: "pulse 1.5s ease-in-out infinite",
          }}
        />
        <div
          style={{
            height: "12px",
            width: "60px",
            backgroundColor: "#e0e0e0",
            borderRadius: "4px",
            animation: "pulse 1.5s ease-in-out infinite",
          }}
        />
      </div>
      <div
        style={{
          height: "20px",
          width: "40px",
          backgroundColor: "#e0e0e0",
          borderRadius: "12px",
          animation: "pulse 1.5s ease-in-out infinite",
        }}
      />
    </div>
  );

  const renderDaySkeleton = () => (
    <div className={`weekly-roster-overview-day-card ${className}`}>
      <div className="weekly-roster-overview-day-header">
        <div
          style={{
            height: "16px",
            width: "40px",
            backgroundColor: "#e0e0e0",
            borderRadius: "4px",
            marginBottom: "4px",
            animation: "pulse 1.5s ease-in-out infinite",
          }}
        />
        <div
          style={{
            height: "14px",
            width: "30px",
            backgroundColor: "#e0e0e0",
            borderRadius: "4px",
            animation: "pulse 1.5s ease-in-out infinite",
          }}
        />
      </div>
      {Array.from({ length: shiftsPerDay }).map((_, index) => (
        <React.Fragment key={index}>{renderShiftSkeleton()}</React.Fragment>
      ))}
    </div>
  );

  return (
    <>
      <style>
        {`
          @keyframes pulse {
            0%, 100% {
              opacity: 0.6;
            }
            50% {
              opacity: 0.3;
            }
          }
        `}
      </style>
      {/* <div className={containerClassName} style={{ margin: "15px 0" }}> */}
      {Array.from({ length: daysCount }).map((_, index) => (
        <React.Fragment key={index}>{renderDaySkeleton()}</React.Fragment>
      ))}
      {/* </div> */}
    </>
  );
};

export default CalendarLoader;